import { render, staticRenderFns } from "./ProfileEducation.vue?vue&type=template&id=63f4581d"
import script from "./ProfileEducation.vue?vue&type=script&lang=ts"
export * from "./ProfileEducation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f4581d')) {
      api.createRecord('63f4581d', component.options)
    } else {
      api.reload('63f4581d', component.options)
    }
    module.hot.accept("./ProfileEducation.vue?vue&type=template&id=63f4581d", function () {
      api.rerender('63f4581d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/ProfileEducation.vue"
export default component.exports